import { render, staticRenderFns } from "./tradeAccountInfo.vue?vue&type=template&id=1f82d7c0&scoped=true&"
import script from "./tradeAccountInfo.vue?vue&type=script&lang=js&"
export * from "./tradeAccountInfo.vue?vue&type=script&lang=js&"
import style0 from "./tradeAccountInfo.vue?vue&type=style&index=0&id=1f82d7c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f82d7c0",
  null
  
)

component.options.__file = "tradeAccountInfo.vue"
export default component.exports